import { render, staticRenderFns } from "./EditProjectDialog.vue?vue&type=template&id=3e5b0df4&scoped=true&"
import script from "./EditProjectDialog.vue?vue&type=script&lang=ts&"
export * from "./EditProjectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditProjectDialog.vue?vue&type=style&index=0&id=3e5b0df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5b0df4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
